import { Component, OnInit, Inject } from '@angular/core';

// esto es loq ue declara y el componente se declara en en module 
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {FormControl, FormGroup} from '@angular/forms';


// esto es para esperar un teimpo antes de realizar una suscripcion por ejemplo

//import { debounceTime } from 'rxjs/operators';


const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();



@Component({
  selector: 'app-dialograngofechas',
  templateUrl: './dialograngofechas.component.html',
  styleUrls: ['./dialograngofechas.component.scss']
})
export class DialograngofechasComponent implements OnInit {
  

  public fechasForm: FormGroup = new FormGroup({
    date : new FormControl (new Date()),
     serializedDate : new FormControl((new Date()))
  });

  //  date = new FormControl(new Date());
  // 

  constructor(
    @Inject (MAT_DIALOG_DATA) public message,
    public dialogRef : MatDialogRef <DialograngofechasComponent>
    ) {

      
     }

  ngOnInit() {
  }

  onClickNo () {

    this.dialogRef.close(true);
  }

   getFecha (event: Event) {
  //   event.preventDefault();
  //   console.log (this.date.value)
  //   console.log (this.serializedDate.value)
  this.dialogRef.close(this.fechasForm.value);
   }

}


/// este jemplo viene de utilerias


